import tmdb from './client';

const Search = (query, config = {}) =>
  tmdb.get('/search/movie', {
    ...config,
    params: {
      query,
      include_adult: false,
      language: 'en-US',
      page: 1,
      ...(config.params || {}),
    },
  });

export default Search;
